import Container from "../UI/Container/Container";
import Layout from "../UI/Layout/Layout";
import Seo from "../UI/Seo/Seo";
import "./legal.css";

const Datenschutz = () => {
  return (
    <Layout authLevelRequired={false}>
      <Seo
        title="Datenschutzerklärung"
        description="Datenschutzerklärung der Wilms Rechtsanwälte GbR – Informationen zum Umgang mit Ihren personenbezogenen Daten gemäß DSGVO."
        path="/datenschutzerklaerung"
      />
      <Container>
        <div className="legal-text my-5 md:my-24">
          <h1>Datenschutz&shy;erkl&auml;rung</h1>
          <p>Sehr geehrte Besucher/innen,</p>
          <p>
            der Schutz Ihrer Privatsphäre ist uns wichtig. Wir sind als Anwälte
            gesetzlich zur Verschwiegenheit verpflichtet. Darüber hinaus gelten
            selbstverständlich auch für uns die gesetzlichen Regelungen zum
            Datenschutz. Mit nachfolgenden Informationen möchten wir Ihnen einen
            Überblick verschaffen, wie wir mit Ihren Daten umgehen, die wir im
            Zusammenhang mit dem Besuch unserer Internetseite erfassen und bei
            der Nutzung unserer anwaltlichen Leistungen bei Ihnen erheben. Zudem
            möchten wir Sie über Ihre Datenschutzrechte informieren. Welche
            Daten im Einzelnen verarbeitet, und wie sie genutzt werden, hängt
            von den jeweils in Anspruch genommenen Leistungen/ dem jeweiligen
            Mandat ab.
          </p>
          <h2>1. Verantwortlicher, Art. 4 Ziffer 7 DSGVO</h2>
          <p>
            Der für die Verarbeitung Ihrer Daten Verantwortliche im Sinne von
            Art. 4 Ziffer 7 Datenschutz – Grundverordnung (DSGVO) ist die
          </p>

          <p>WILMS Rechtsanwälte GbR</p>
          <p>Alt-Tempelhof 41</p>
          <p>12103 Berlin</p>
          <h2>2. Was sind „Personenbezogene Daten"?</h2>
          <p>
            Personenbezogene Daten sind Informationen zu Ihrer Person, die
            Rückschlüsse auf Ihre Identität zulassen, z.B. Ihr Name, Ihre
            Adresse oder Ihre Telefonnummer. Informationen, die keine
            Rückschlüsse auf eine bestimmte oder bestimmbare Person zulassen,
            fallen nicht darunter.
          </p>
          <h2>3. Umfang der Datenerhebung, -verarbeitung und -nutzung</h2>
          <h3>a) Auf unserer Internetseite</h3>
          <p className="bold">
            aa) Kontaktaufnahme per Mail oder Kontaktformular
          </p>
          <p>
            Bei Ihrer Kontaktaufnahme mit uns per E-Mail oder über ein
            Kontaktformular werden die von Ihnen mitgeteilten Daten (Ihre
            E-Mail-Adresse, bei Rückrufwunsch Ihr Name und Ihre Telefonnummer)
            von uns gespeichert, um Ihre Fragen oder Anliegen zu beantworten
          </p>
          <p className="bold">bb) Besuch unserer Internetseite</p>
          <p>
            Beim rein informatorischen Besuch unserer Internetseite, also wenn
            Sie sich nicht registrieren oder uns anderweitig Informationen
            übermitteln, erheben wir nur die personenbezogenen Daten, die Ihr
            Browser an unseren Server übermittelt. Wenn Sie unsere Website
            betrachten möchten, erheben wir die folgenden Daten, die für uns
            technisch erforderlich sind, um Ihnen unsere Website anzuzeigen und
            die Stabilität und Sicherheit zu gewährleisten:
          </p>
          <p>- IP-Adresse (wird anonymisiert)</p>
          <p>- Datum und Uhrzeit der Anfrage</p>
          <p>- Inhalt der Anforderung (konkrete Seite)</p>
          <p>- Website, von der die Anforderung kommt</p>
          <p>- Browser</p>
          <p>- Betriebssystem und dessen Oberfläche</p>
          <p>- Sprache und Version der Browsersoftware</p>
          <p className="bold">cc) Cookies</p>
          <p>
            Auf unseren Internetseiten können so genannte Cookies eingesetzt
            werden. Diese dienen dazu, unser Angebot nutzerfreundlicher,
            effektiver und sicherer zu machen. Cookies sind kleine Textdateien,
            die auf Ihrem Rechner abgelegt werden, und die Ihr Browser
            speichert. Etwaige von uns verwendete Cookies sind so genannte
            „Session-Cookies“. Sie werden nach Ende Ihres Besuchs automatisch
            gelöscht. Cookies richten auf Ihrem Rechner keinen Schaden an und
            enthalten keine Viren.
          </p>

          <p>
            Um den Einsatz von Cookies zu unterbinden, können Sie Ihre
            Browser-Einstellung entsprechend Ihren Wünschen konfigurieren und
            z. B. die Annahme von Third-Party-Cookies oder allen Cookies
            ablehnen. Wir weisen Sie darauf hin, dass Sie eventuell nicht alle
            Funktionen dieser Website nutzen können.
          </p>
          <p className="bold">b) Datenverarbeitung im Rahmen des Mandats</p>
          <p>
            Wenn Sie uns mandatieren wollen, erheben wir Namen, Adresse und
            weitere Kontaktdaten, damit wir mit Ihnen kommunizieren können. Die
            Daten werden bei uns gespeichert und im Rahmen der
            Mandatsbearbeitung genutzt. Je nach Mandat fragen wir weitere Daten
            bei Ihnen ab, die wir für unsere Arbeit brauchen. Hierzu gehören
            beispielsweise Daten zu Ihrer Rechtsschutzversicherung oder anderen
            Versicherungen, aber auch Ihre Bankverbindung, wenn wir Gelder an
            Sie auszahlen sollen.
          </p>
          <h2>4. Zweck der Verarbeitung und Rechtsgrundlage</h2>

          <p>
            Wir verarbeiten personenbezogene Daten gemäß den Bestimmungen der
            Europäischen Datenschutzgrundverordnung (DSGVO) und dem
            Bundesdatenschutzgesetz (BDSG).
          </p>
          <h3>
            a) Zur Erfüllung vertraglicher Pflichten (Art. 6 Abs. 1 b) DSGVO)
          </h3>
          <p>
            Die Verarbeitung von Daten erfolgt zur Erbringung unserer
            vertraglichen Leistungen im Rahmen eines Mandats oder zur
            Durchführung vorvertraglicher Maßnahmen, die auf Ihre Anfrage hin
            erfolgen. Der Zweck der Maßnahme richtet sich vorrangig nach dem
            konkreten Inhalt des Mandats bzw. Ihrer Anfrage.
          </p>
          <h3>b) Im Rahmen der Interessenabwägung (Art. 6 Abs. 1 f) DSGVO)</h3>
          <p>
            Über die Nutzung zur eigentlichen Vertragserfüllung hinaus kann es
            erforderlich sein, Ihre Daten zur Wahrung berechtigter Interessen
            von uns oder Dritten zu verarbeiten, z.B.
          </p>

          <p>- Analyse der Nutzung unserer Internetseite</p>
          <p>
            - Erstellung von Zugriffsstatistiken ohne jeden Personenbezug und zu
            Zwecken der Identifikation und Nachverfolgung unzulässiger
            Zugriffsversuche und Zugriffe auf den Web-Server durch eigens hierzu
            berechtigte Personen
          </p>
          <p>- Gewährleistung der IT-Sicherheit unseres Systems</p>
          <p>
            - Geltendmachung eigener rechtlicher Ansprüche und Verteidigung bei
            rechtlichen Streitigkeiten
          </p>
          <h3>c) Aufgrund Ihrer Einwilligung (Art. 6 Abs. 1 a) DSGVO)</h3>
          <p>
            Für bestimmte Zwecke (z.B. Übermittlung von Daten an Dritte und/oder
            in Drittstaaten) benötigen wir Ihre Einwilligung. Eine Verarbeitung
            findet insoweit nur statt, wenn Sie diese Einwilligung ausdrücklich
            erteilt haben. Sie können Ihre Einwilligung jederzeit widerrufen.
            Der Widerruf berührt nicht die Rechtmäßigkeit der Verarbeitung vor
            Zugang des Widerrufs.
          </p>
          <h2>5. Empfänger der Daten</h2>
          <p>
            - Daten, die wir auf unserer Internetseite in Server Log-Files
            erfassen, werden nicht an Dritte übermittelt.
          </p>
          <p>
            - Empfänger Ihrer Daten können andere Rechtsanwälte als
            Unterbeauftragte sein, die in Einzelfällen und nach Absprache mit
            Ihnen Gerichtstermine oder andere Termine wahrnehmen.
          </p>
          <p>
            - Wenn die Kosten unserer anwaltlichen Leistungen über eine
            Rechtschutzversicherung abgerechnet werden sollen, übermitteln wir
            personenbezogene Daten an Ihren Versicherer (z.B. im Rahmen der
            Deckungsanfrage).
          </p>
          <p>
            - Wenn Sie uns mandatieren, übermitteln wir personenbezogene Daten
            im Rahmen des Mandats an Gerichte, Behörden, Versicherungen,
            Sachverständige und andere Verfahrensbeteiligte.
          </p>
          <h2>6. Übermittlung von Daten in ein Drittland</h2>
          <p>
            An Empfänger mit Sitz außerhalb der EU und des EWR übermitteln wir
            Daten nur mit Ihrer ausdrücklichen Einwilligung oder soweit dies
            gesetzlich vorgeschrieben ist. Eine Übermittlung in Drittländer kann
            insbesondere dann erforderlich sein, wenn Gerichte, Behörden oder
            andere Verfahrensbeteiligte ihren Sitz in einem Drittland haben.
            Eine Übermittlung erfolgt aber auch in diesem Fall nur, soweit dies
            nach Art. 44 ff. DSGVO erlaubt ist.
          </p>
          <h2>7. Dauer der Speicherung</h2>
          <p>
            Wir speichern Ihre Daten grundsätzlich nur so lange, wie die
            Speicherung für die Erfüllung vertraglicher und gesetzlicher
            Pflichten erforderlich ist. Sind die Daten hierfür nicht mehr
            erforderlich, werden sie regelmäßig gelöscht.
          </p>

          <p>
            Protokolldaten unserer Internetseite (Server-Logfiles) werden
            beispielsweise für die Dauer von 30 Tagengespeichert und dann
            automatisch gelöscht.
          </p>

          <p>
            Daten, die Sie uns im Rahmen von Anfragen zukommen lassen, verwenden
            wir zur Beantwortung Ihrer Anfrage und speichern sie für 30 Tage, um
            Rückfragen beantworten zu können. Erfolgt keine weitere Reaktion,
            dann werden die Daten gelöscht.
          </p>

          <p>
            Daten, die in Session Cookies erfasst werden, werden mit Schließen
            des Browsers gelöscht.
          </p>

          <p>Eine Löschung von Daten erfolgt nicht, soweit und solange</p>

          <p>
            - Handels- und steuerrechtliche Aufbewahrungspflichten
            entgegenstehen,
          </p>
          <p>
            - Daten zum Nachweis von Forderungen aus dem Vertragsverhältnis
            erhalten bleiben müssen, im Rahmen der regelmäßigen Verjährungsfrist
            (3 Jahre, § 195 BGB).
          </p>
          <p>
            Soweit eine Löschung nach vorstehendem Satz nicht erfolgt, werden
            die Daten gesperrt.
          </p>

          <p>
            Die Erforderlichkeit der Datenspeicherung wird in regelmäßigen
            Abständen überprüft, mindestens aber alle 2 Jahre.
          </p>
          <h2>8. Sicherheit Ihrer Daten</h2>

          <p>
            Wir treffen alle angemessenen technisch-organisatorische Maßnahmen,
            um den Schutz Ihrer Daten zu gewährleisten. Dritte, die in unserem
            Auftrag Ihre Daten verarbeiten oder mit diesen in Kontakt kommen
            können, werden entsprechend den gesetzlichen Vorgaben schriftlich
            zur Einhaltung der datenschutzrechtlichen Vorschriften verpflichtet.
            Unsere Mitarbeiter sind alle auf das Datengeheimnis verpflichtet.
          </p>
          <h2>9. Ihre Datenschutzrechte</h2>
          <p>Als „betroffene Person“ haben Sie das Recht auf</p>

          <p>- Auskunft nach Art. 15 DSGVO</p>
          <p>- Berichtigung nach Art. 16 DSGVO</p>
          <p>- Löschung nach Art. 17 DSGVO</p>
          <p>- Einschränkung der Verarbeitung nach Art. 18 DSGVO</p>
          <p>
            - Widerspruch aus Art. 21 DSGVO gegen die Verarbeitung nach Art. 6
            Abs. 1 f) DSGVO sowie
          </p>
          <p>- Datenübertragbarkeit aus Art. 20 DSGVO.</p>
          <p>
            Beim Auskunftsrecht und beim Löschungsrecht gelten die
            Einschränkungen nach §§ 34 und 35 BDSG (n.F.). Sie haben auch das
            Recht, sich bei der zuständigen Datenschutzbehörde zu beschweren
            (Art. 77 DSGVO i.V. m. § 19 BDSG (n.F.)).
          </p>
          <h2>10. Pflicht zur Bereitstellung von Daten</h2>
          <p>
            Sie sind gesetzlich nicht verpflichtet, uns Daten zur Verfügung zu
            stellen.
          </p>

          <p>
            Für die Inanspruchnahme unserer Leistungen ist es jedoch
            erforderlich, dass Sie uns einige Daten mitteilen, die für die
            Erbringung der jeweiligen Leistung benötigt werden. Wenn Sie
            beispielsweise Kontakt zu uns aufnehmen, brauchen wir eine
            Mailadresse oder eine Telefonnummer, wenn Sie zurückgerufen werden
            möchten. Andernfalls können wir Ihre Anfrage nicht beantworten.
          </p>

          <p>
            Wenn Sie uns mandatieren möchten, benötigen wir Ihren Namen, Ihre
            Adresse und weitere Kontaktdaten (wie Telefonnummer oder
            Mailadresse), damit wir mit Ihnen korrespondieren können. Sollen wir
            Geld für Sie in Empfang nehmen, dann müssen Sie uns Ihre Bankdaten
            mitteilen. Im Rahmen der Mandatsbearbeitung kann es – abhängig vom
            jeweiligen Mandat – erforderlich sein, dass Sie uns auch besondere
            Kategorien von Daten (z.B. Gesundheitsdaten) überlassen müssen,
            damit wir Ihre Interessen vertreten können.
          </p>

          <p>
            Ohne die Zurverfügungstellung von Daten ist eine Nutzung unserer
            Leistungen nicht möglich und können wir keine Leistungen erbringen
            bzw. kein Mandatsverhältnis mit Ihnen eingehen.
          </p>
          <h2>11. Automatisierte Entscheidungsfindung und Profiling</h2>
          <p>
            Eine Automatisierte Entscheidungsfindung und/oder Profiling im Sinne
            von Art. 22 Abs. 1 und 4 DSGVO finden nicht statt.
          </p>

          <h2>12. Datenschutzbeauftragter</h2>
          <p>
            Wenn Sie Fragen oder Anmerkungen zum Thema Datenschutz haben, senden
            Sie uns eine E-Mail an datenschutz(at)wilms.eu.
          </p>

          <h2>13. Änderungen der Datenschutzerklärung</h2>
          <p>
            Wir behalten uns vor, die Regelungen unserer Datenschutzerklärung
            von Zeit zu Zeit anzupassen. Ältere Fassungen der
            Datenschutzerklärung können Sie über die o.g. Mailadresse bei uns
            anfordern.
          </p>
          <br />
          <p>V 3.0 Berlin im Mai 2018</p>
        </div>
      </Container>
    </Layout>
  );
};

export default Datenschutz;
